const extractStatus = data => {
  if (Object.prototype.hasOwnProperty.call(data, "status")) return data.status;
  if (
    data.detail &&
    Object.prototype.hasOwnProperty.call(data.detail, "status")
  )
    return data.detail.status;
  return undefined;
};

const isCesResultForMessage = (data, messageId) =>
  data &&
  data.event === "cesResult" &&
  (!data.message_id || data.message_id === messageId);

/**
 * Checks if an email is registered by pushing a GTM event and listening for the response.
 * Resolves true if available for registration, false if already registered.
 */
export const checkEmailStatus = email =>
  new Promise((resolve, reject) => {
    const encodedEmail = btoa(unescape(encodeURIComponent(email)));
    const messageId = Math.random().toString(36).slice(2, 11);
    const gtmDataLayer =
      (window.parent && window.parent.gtmDataLayer) || window.gtmDataLayer;

    if (!gtmDataLayer) {
      reject(new Error("gtmDataLayer not found"));
      return;
    }

    const originalPush = gtmDataLayer.push;
    let settled = false;

    const timeoutId = setTimeout(() => {
      if (!settled) {
        cleanup();
        reject(new Error("Request timeout"));
      }
    }, 2000);

    const cleanup = () => {
      clearTimeout(timeoutId);
      gtmDataLayer.push = originalPush;
      settled = true;
    };

    gtmDataLayer.push = function (data) {
      const result = originalPush.call(this, data);
      if (!settled && isCesResultForMessage(data, messageId)) {
        const status = extractStatus(data);
        if (typeof status === "boolean") {
          cleanup();
          resolve(!!status);
        } else if (status !== undefined) {
          cleanup();
          reject(new Error("Unexpected response format"));
        }
      }
      return result;
    };

    gtmDataLayer.push({
      event: "ces",
      etc: encodedEmail,
      message_id: messageId,
      event_callback: function () {}
    });
  });
